export default {
    CASADO: 1,
    CONVIVENTE: 2,
}